import VideoPlayer, { VideoPlayerT } from './VideoPlayer';

export {
  VideoPlayerT,
};

export default VideoPlayer;
